import React from "react";
import { useTranslation } from "react-i18next";

const LanguageButton = ({ lang, label, isActive, onClick }) => (
	<button
		onClick={onClick}
		className={`text-md flex justify-center items-center rounded-lg font-medium w-10 h-10 border-[1px] border-solid ${
			isActive
				? "bg-second_color text-white"
				: "text-second_color border-second_color"
		}`}
		aria-label={`Change language to ${label}`}>
		{label}
	</button>
);

const SelectLanguage = ({ pathname }) => {
	const { i18n } = useTranslation();

	const handleLanguageChange = (lang) => {
		i18n.changeLanguage(lang);
		localStorage.setItem("language", lang);
		window.location.reload(); // Consider replacing this with a more efficient method
	};

	return (
		<section className='flex justify-center gap-1 px-3'>
			<LanguageButton
				lang='ar'
				label={i18n.language === "ar" ? "ع" : "Ar"}
				isActive={i18n.language === "ar" && pathname !== ""}
				onClick={() => handleLanguageChange("ar")}
			/>
			<LanguageButton
				lang='en'
				label='En'
				isActive={i18n.language === "en" && pathname !== ""}
				onClick={() => handleLanguageChange("en")}
			/>
		</section>
	);
};

export default SelectLanguage;
